import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Styles from "./styles.scss";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const BUTTON_TYPE = {
  PRIMARY: { STYLE: "button-primary" },
  SECONDARY: { STYLE: "button-secondary" },
  DISABLED: { STYLE: "button-disabled" },
  BACKGROUND: { STYLE: "button-background" },
  UTILITY: { STYLE: "button-utility" }
};

class AuditButton extends Component {
  static propTypes = {
    labelId: PropTypes.string,
    type: PropTypes.any,
    icon: PropTypes.any,
    block: PropTypes.bool,
    disabled: PropTypes.bool,
    marginRight: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.object
  };
  static defaultProps = {
    labelId: "common.ok",
    type: BUTTON_TYPE.PRIMARY,
    icon: "star",
    block: false,
    disabled: false,
    marginRight: false
  };
  render() {
    const { labelId, type, block, disabled, marginRight } = this.props;
    const buttonStyle = disabled
      ? Styles[BUTTON_TYPE.DISABLED.STYLE]
      : Styles[type.STYLE]
        ? Styles[type.STYLE]
        : "button-primary";
    const marginStyle = marginRight ? Styles["margin-right"] : "";
    return (
      <Button
        className={
          Styles["button-audit"]
            ? Styles["button-audit"]
            : "button-audit" + " " + buttonStyle + " " + marginStyle
        }
        size="sm"
        block={block}
        disabled={disabled}
        onClick={this.props.onClick}
      >
        {this.props.children ? this.props.children : null}
        <div>
          <FormattedMessage id={labelId} />
        </div>
      </Button>
    );
  }
}

export { AuditButton, BUTTON_TYPE };
